import apiService from './apiService';

export interface MasterPlantRequiringIsolationPayload {
  title: string;
}

const resource = '/plant-requiring-isolations';

export const getMasterPlantRequiringIsolations = async () => {
  const response = await apiService.get(resource);
  return response.data;
};

export const createMasterPlantRequiringIsolation = async (payload: MasterPlantRequiringIsolationPayload) => {
  const response = await apiService.post(resource, payload);
  return response.data?.data ?? response.data;
};

export const updateMasterPlantRequiringIsolation = async (id: number, payload: MasterPlantRequiringIsolationPayload) => {
  const response = await apiService.put(`${resource}/${id}`, payload);
  return response.data?.data ?? response.data;
};

export const deleteMasterPlantRequiringIsolation = async (id: number) => {
  const response = await apiService.delete(`${resource}/${id}`);
  return response.data;
};
